export function mapProfileToTeacher(profile) {
  return {
    id: profile.user.id,
    userId: profile.user.id,
    slug: profile.user.slug,
    profileId: profile.id,
    firstName: profile.user.first_name,
    lastName: profile.user.last_name,
    email: profile.user.email,
    phone: profile.user.phone ?? '',
    status: profile.user.status,
    dob: profile.dob,
    avatar: profile.avatar,
    bio: profile.bio,
    videoUrl: profile.intro_video_url || '',
    subjectCategory: profile.subject_category ?? '',
    code: profile.teacher_code,

    subjects: profile.subjects ?? [],
    medium: profile.mediums ?? [],
    classTypes: profile.class_types ?? [],
    cities: profile.cities ?? [],

    qualifications: profile.qualifications ?? [],
    timeSlots: profile.time_slots ?? {
      SUN: [],
      MON: [],
      TUE: [],
      WED: [],
      THU: [],
      FRI: [],
      SAT: [],
    },

    reviews: profile.reviews ?? [],
    recommendations: profile.recommendations ?? [],

    rating: (() => {
      const reviews = profile.reviews ?? [];
      if (!reviews.length) return 0;
      const sum = reviews.reduce((a, b) => a + b.rating, 0);
      return sum / reviews.length;
    })(),
  };
}
